import cloudIcon from "@assets/images/cloud.svg";
import { Box, Button, Card } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import React, { FC } from "react";

import useStyle from "./stylesCreateErrorView";

interface CreateErrorViewProps {
  onConfirm: () => void;
  topicText: string;
}
const CreateErrorView: FC<CreateErrorViewProps> = ({
  onConfirm,
  topicText
}) => {
  const classes = useStyle();
  return (
    <Card className={classes.root} data-testid="createErrorView">
      <Box className={classes.header}>
        <img src={cloudIcon} alt="" className={classes.cloudIcon} />
        <MyTypography
          variant="h6"
          className={classes.title}
          data-testid="title"
        >
          การประมวลผลคำสั่งซื้อ {topicText}
        </MyTypography>
        <MyTypography variant="body2" className={classes.subtitle}>
          กรุณาตรวจเช็คอีเมลของคุณ
          <br />
          หากคุณไม่ได้รับอีเมลโปรดติดต่อ Admin
        </MyTypography>
      </Box>
      <Button
        data-testid="confirmButton"
        color="primary"
        variant="contained"
        className={classes.btnAction}
        fullWidth={true}
        onClick={onConfirm}
      >
        <MyTypography variant="body1">กลับไปหน้าแรก</MyTypography>
      </Button>
    </Card>
  );
};

export default CreateErrorView;
